import React, { useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Arrow } from "../../svgs/wallet-arrow.svg";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { withdrawAmount as withdrawRequest } from "../../../utils/API/withdrawAmount";
import { LoadingOutlined } from "@ant-design/icons";

const SelectWithdrawAccount = ({
  open,
  onCancel,
  data,
  withdrawAmount,
  setWalletDetails,
  setWithdrawConfirm,
  updateData,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [currentAccount, setCurrentAccount] = useState(0);

  const accounts = data.filter((item) => item.account_status === "Verified");
  const account = accounts[currentAccount];

  const withdrawHandler = async () => {
    try {
      setLoading(true);
      const { updatedWallet } = await withdrawRequest(
        withdrawAmount,
        account._id,
        dispatch
      );
      setWalletDetails({ ...updatedWallet, wallet_id: updatedWallet._id });
      updateData();
      onCancel();
      setWithdrawConfirm(true);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <DiaglogBox
      open={open}
      width={"fit-content"}
      onCancel={onCancel}
      closeIcon={false}
    >
      <div className="px-8 pt-6 pb-4">
        <h4 className=" text-lg font-bold mb-2">Select the Account</h4>
        <div className="account-details flex flex-col">
          <div className="flex gap-x-4 items-center">
            <Button
              disabled={currentAccount <= 0}
              className={` py-1 px-2 h-fit ${
                currentAccount > 0 ? "bg-blue-300" : "bg-gray-200"
              }`}
              varient={"rounded"}
              onClick={() => {
                if (currentAccount > 0) setCurrentAccount(currentAccount - 1);
              }}
            >
              <Arrow
                className={`w-6 h-3 rotate-180  ${
                  currentAccount > 0 ? "text-blue-800" : "text-gray-400"
                }`}
              />
            </Button>
            <h4 className="text-xl font-normal">Account Details</h4>
            <Button
              disabled={currentAccount >= accounts.length - 1}
              className={` py-1 px-2 h-fit ${
                currentAccount < accounts.length - 1
                  ? "bg-blue-300"
                  : "bg-gray-200"
              }`}
              varient={"rounded"}
              onClick={() => {
                if (currentAccount < accounts.length - 1)
                  setCurrentAccount(currentAccount + 1);
              }}
            >
              <Arrow
                className={`w-6 h-3 ${
                  currentAccount < accounts.length - 1
                    ? "text-blue-800"
                    : "text-gray-400"
                }`}
              />
            </Button>
          </div>

          {accounts.length === 0 ? (
            <div className="text-center h-full mt-6">No Account found!</div>
          ) : (
            <table className="mt-2 text-xs">
              <tbody>
                <tr>
                  <td className="text-xs font-medium">Account Owner</td>
                  <td className="px-2">-</td>
                  <td className=" capitalize">{account?.account_owner_name}</td>
                </tr>
                <tr>
                  <td className="text-xs font-medium">Account no</td>
                  <td className="px-2">-</td>
                  <td>{account?.account_no}</td>
                </tr>
                <tr>
                  <td className="text-xs font-medium">Bank</td>
                  <td className="px-2">-</td>
                  <td className=" capitalize">{account?.bank_name}</td>
                </tr>

                <tr>
                  <td className="text-xs font-medium">Location</td>
                  <td className="px-2">-</td>
                  <td className=" capitalize max-w-[72px] truncate">
                    {account?.bank_address}
                  </td>
                </tr>

                <tr>
                  <td className="text-xs font-medium">Account Type</td>
                  <td className="px-2">-</td>
                  <td className=" capitalize">{account?.account_type}</td>
                </tr>

                <tr>
                  <td className="text-xs font-medium">IFSC Code</td>
                  <td className="px-2">-</td>
                  <td>{account?.IFSC_code}</td>
                </tr>

                <tr>
                  <td className="text-xs font-medium">Swift Code</td>
                  <td className="px-2">-</td>
                  <td>{account?.swift_code}</td>
                </tr>

                <tr>
                  <td className="text-xs font-medium">MICR Code</td>
                  <td className="px-2">-</td>
                  <td>{account?.MICR_code}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
        <div className="flex gap-x-4 mt-4">
          <Button
            className={"w-1/2 py-2 text-white font-bold"}
            color={"blue"}
            varient={"primary"}
            onClick={withdrawHandler}
          >
            {loading ? <LoadingOutlined /> : "Select"}
          </Button>

          <Button
            onClick={onCancel}
            className={"w-1/2 py-2 bg-[#C9020220] font-bold text-[#C90202]"}
            varient={"primary"}
          >
            Cancel
          </Button>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default SelectWithdrawAccount;
